import { BaseModel } from './base.model';

export class FilterItem extends BaseModel {
  public id: any;
  public attr_id: any;
  public ord: number;
  public label: string;
  public selected: boolean;
  public isChild: boolean;
  public isVisible = true;
  // derived properties
  public children: FilterItem[];
  public max_price: number | string;
  public min_price: number | string;

  public inputMinPrice: string;
  public inputMaxPrice: string;

  private _minPrice: number;
  private _maxPrice: number;

  constructor(data) {
    super(data, {
      num: ['ord'],
      bool: ['selected'],
    });

    if (!this.children) {
      this.children = [];
    } else {
      this.children = this.children.map((item) => new FilterItem(item));
    }

    if (!this.ord) {
      this.ord = 0;
    }

    this.setPrices();
  }

  public clearSelection() {
    this.selected = false;
    this.children.forEach((child) => child.clearSelection());
  }

  public hasPriceRange(): boolean {
    return this._maxPrice > 0;
  }

  public get maxPrice(): number {
    return this._maxPrice;
  }

  public get minPrice(): number {
    return this._minPrice;
  }

  private setPrices(): void {
    this.max_price = Math.ceil(
      !!this.max_price ? parseFloat(this.max_price as string) : 0
    );
    this.min_price = Math.floor(
      !!this.min_price ? parseFloat(this.min_price as string) : 0
    );

    this._maxPrice = this.max_price;
    this._minPrice = this.min_price;

    this.inputMaxPrice = this._maxPrice.toString();
    this.inputMinPrice = this._minPrice.toString();
  }
}
